import React, { useState } from "react"
import axios from "axios"
import { ContactForm as FormComponent } from "@organic-return/foundation-react/src/components/Forms/ContactForm"
import { useSiteContext } from "../common/SiteContext"
import { getRecaptchaToken, getSegmentAnonymousId, registerSegmentActivity } from "../../lib/utils"
import { graphql } from "gatsby"

const ContactForm = (props: any) => {
  const siteContext = useSiteContext()
  const formChildren = props.text ? (
    <div dangerouslySetInnerHTML={{ __html: props.text }}></div>
  ) : siteContext.globalContactFormProps?.children

  if (siteContext.globalContactFormProps?.radiobtnGroup && siteContext.globalContactFormProps.radiobtnGroup.list?.[0] && props.choiceControlText) {
    siteContext.globalContactFormProps.radiobtnGroup.label = props.choiceControlText
  }

  return (
    <FormComponent
      title={props.title}
      classNames="max-w-screen-lg mx-auto"
      clickHandler={async formInput => {
        const recaptchaToken = await getRecaptchaToken("contact_us");
        await axios({
          url: process.env.LEAD_CREATE_API_ENDPOINT,
          method: "POST",
          data: {
            recaptchaToken,
            formValues: formInput,
            propertyInfo: {
              createdFrom: `Contact US - ${props.title}`,
            },
            segmentAnonymousId: getSegmentAnonymousId(),
          },
        })
        registerSegmentActivity(`Contact Us Form Submission`, formInput)
      }}
      {...siteContext.globalContactFormProps}
    >
      {formChildren}
    </FormComponent>
  )
}

export default ContactForm

export const query = graphql`
fragment DrupalContactFormContent on DrupalContactForm {
  title
  subTitle
  target
  text
}
`